import { muiColors } from '../mui/DefaultTheme'

const fontUrls = [
  {
    name: 'Apax Regular',
    localName: 'Apax Regular',
    url: 'https://cdn.zuto.cloud/assets/fonts/ApaxThree-Regular.woff2'
  },
  {
    name: 'Apax Medium',
    localName: 'ApaxThree-Medium',
    url: 'https://cdn.zuto.cloud/assets/fonts/ApaxThree-Medium.woff2'
  },
  {
    name: 'Apax Bold',
    localName: 'Apax Bold',
    url: 'https://cdn.zuto.cloud/assets/fonts/ApaxThree-Bold.woff2'
  },
  {
    name: 'Apax Light',
    localName: 'Apax Light',
    url: 'https://cdn.zuto.cloud/assets/fonts/ApaxThree-Light.woff2'
  }
]

const fonts = {
  medium: '"Apax Medium", Helvetica, sans-serif',
  regular: '"Apax Regular", Helvetica, sans-serif',
  bold: '"Apax Bold", Helvetica, sans-serif',
  light: '"Apax Light", Helvetica, sans-serif'

}

const textStyles = {
  display: {
    extraLarge: {
      bold: {
        fontSize: ['42px', '64px'],
        fontWeight: 700,
        lineHeight: ['44px', '64px'],
        fontFamily: fonts.bold
      }
    },
    large: {
      medium: {
        fontSize: ['36px', '48px'],
        lineHeight: ['38px', '52px'],
        fontWeight: 500,
        fontFamily: fonts.medium
      },
      bold: {
        fontSize: ['34px, 52px'],
        lineHeight: ['36px', '54px'],
        fontWeight: 500,
        fontFamily: fonts.bold
      }
    },
    standard: {
      medium: {
        fontSize: ['24px', '26px'],
        fontFamily: fonts.medium,
        lineHeight: ['32px', '30px']
      },
      bold: {
        fontSize: ['24px', '32px'],
        fontFamily: fonts.bold,
        lineHeight: ['28px', '36px']
      }
    },
    small: {
      medium: {
        fontSize: '20px',
        fontFamily: fonts.medium,
        lineHeight: '24px'
      },
      bold: {
        fontSize: '20px',
        fontFamily: fonts.bold,
        lineHeight: '24px'
      }
    }
  },
  body: {
    large: {
      regular: {
        fontSize: '22px',
        fontFamily: fonts.regular,
        lineHeight: '34px'
      },
      medium: {
        fontSize: '22px',
        fontFamily: fonts.medium,
        lineHeight: '34px'
      }
    },
    regular: {
      regular: {
        fontSize: '18px',
        fontFamily: fonts.regular,
        lineHeight: '26px'
      },
      medium: {
        fontSize: '18px',
        fontFamily: fonts.medium,
        lineHeight: '26px'
      },
      normal: {
        fontSize: '16px',
        fontFamily: fonts.medium,
        lineHeight: '26px'
      },
      small: {
        fontSize: '14px',
        fontFamily: fonts.medium,
        lineHeight: '24px'
      }
    },
    current: {
      regular: {
        fontSize: '16px',
        fontFamily: fonts.regular,
        lineHeight: '24px'
      },
      medium: {
        fontSize: '16px',
        fontFamily: fonts.medium,
        lineHeight: '24px'
      }
    },
    smallPrint: {
      regular: {
        fontSize: '14px',
        fontFamily: fonts.regular,
        lineHeight: '20px'
      },
      medium: {
        fontSize: '14px',
        fontFamily: fonts.medium,
        lineHeight: '20px'
      }
    },
    xsPrint: {
      regular: {
        fontSize: '12px',
        fontFamily: fonts.regular,
        lineHeight: '16px'
      },
      bold: {
        fontSize: '12px',
        fontFamily: fonts.bold,
        lineHeight: '16px'
      }
    }
  },
  material: {
    display: {
      regular: {
        large: {
          fontSize: ['28px', '32px'],
          fontFamily: fonts.medium,
          lineHeight: ['36px', '42px'],
          fontWeight: 700
        }
      }
    },
    body: {
      large: {
        bold: {
          fontSize: '22px',
          fontFamily: fonts.medium,
          lineHeight: '34px',
          fontWeight: 700
        },
        light: {
          fontSize: '24px',
          fontFamily: fonts.light,
          lineHeight: '32px'
        }
      },
      medium: {
        bold: {
          fontSize: '20px',
          fontFamily: fonts.medium,
          lineHeight: '34px',
          fontWeight: 700
        },
        regular: {
          fontSize: '20px',
          fontFamily: fonts.regular,
          lineHeight: '32px',
          color: muiColors.primary.blackAlt
        },
        light: {
          fontSize: '20px',
          fontFamily: fonts.light,
          lineHeight: '32px'
        },
        smallLineHeight: {
          fontSize: '20px',
          fontFamily: fonts.medium,
          lineHeight: '32px'
        }
      },
      current: {
        bold: {
          fontSize: '16px',
          fontFamily: fonts.bold,
          lineHeight: '24px',
          fontWeight: 700
        }
      },
      smallPrint: {
        bold: {
          fontSize: '14px',
          fontFamily: fonts.medium,
          lineHeight: '20px',
          fontWeight: 700
        }
      },
      xsPrint: {
        medium: {
          fontSize: '12px',
          fontFamily: fonts.medium,
          lineHeight: '16px'
        },
        small: {
          fontSize: '11px',
          fontFamily: fonts.medium,
          lineHeight: '16px',
          letterSpacing: '1px'
        }
      }
    }
  },
  prominentColourScheme: {
    body: {
      small: {
        fontSize: '16px',
        fontFamily: fonts.medium,
        lineHeight: '24px'
      }
    }
  }
}
const texts = {
  label: {
    ...textStyles.body.current.regular,
    color: 'neutrals.3',
    mb: 3
  },
  experimental: {
    ...textStyles.material.body.xsPrint.small,
    color: 'neutrals.6'
  },
  error: {
    ...textStyles.body.current.regular,
    color: 'error.2',
    mt: 3,
    svg: {
      path: {
        fill: 'error.2'
      },
      circle: {
        stroke: 'error.2'
      },
      mr: 3
    }
  },
  checkbox: {
    standard: {
      ...textStyles.body.regular.regular,
      color: 'neutrals.4'
    },
    small: {
      ...textStyles.body.smallPrint.regular,
      color: 'neutrals.4'
    }
  }
}

export {
  fontUrls, fonts, textStyles, texts
}
